import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TeacherPendingActionsWidgetOpen {
    isOpen: boolean;
}
const initialState: TeacherPendingActionsWidgetOpen = {
    isOpen: true,
};
const TeacherPendingActionsWidgetOpenSlice = createSlice({
    name: 'TeacherPendingActionsWidgetOpenSlice',
    initialState,
    reducers: {
        setTeacherPendingActionsWidgetOpen: (state, action: PayloadAction<boolean>) => {
            state.isOpen = action.payload;
        },
    },
});

export const { setTeacherPendingActionsWidgetOpen } = TeacherPendingActionsWidgetOpenSlice.actions;
export default TeacherPendingActionsWidgetOpenSlice.reducer;
